import React, { useState, useEffect, useRef } from "react";
import "../Assets/CSS/Navbar.scss";
import logo from "../Assets/Images/logo.png";
import { FaBars, FaTimes, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const navbarRef = useRef(null);
  const location = useLocation();
  const isInsightsActive =
    location.pathname.startsWith("/blog") ||
    location.pathname.startsWith("/casestudies") ||
    location.pathname.startsWith("/news");

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const closeMobileMenu = () => {
    setIsOpen(false);
    setOpenDropdown(null);
  };

  useEffect(() => {
    setOpenDropdown(null);
    setIsOpen(false); // also close mobile menu
  }, [location.pathname]);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <nav
      ref={navbarRef}
      className={`navbar ${scrolled ? "scrolled" : ""}`}
    >

      {/* Logo */}
      <NavLink to="/" className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
      </NavLink>

      {/* Links */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li>
          <NavLink
            to="/"
            onClick={closeMobileMenu}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Home
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/about-us"
            onClick={closeMobileMenu}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            About Us
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/product"
            onClick={closeMobileMenu}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Products
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/service"
            onClick={closeMobileMenu}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Services
          </NavLink>

        </li>

        {/* Dropdown */}
        {/* Mega Menu */}
        <li
          className={`dropdown mega ${openDropdown === "insights" ? "active" : ""
            }`}
        >
          <div
            className={`dropdown-label ${isInsightsActive ? "active-link" : ""
              }`}
            onClick={() => toggleDropdown("insights")}
          >
            Insights
            {openDropdown === "insights" ? (
              <FaChevronUp size={14} />
            ) : (
              <FaChevronDown size={14} />
            )}
          </div>

          <div className="mega-menu">
            <div className="mega-content">

              <NavLink
                to="/blog"
                className="mega-column"
                onClick={closeMobileMenu}
              >
                <h4>Blog</h4>
                <p>Industry insights, product updates & expert articles.</p>
                <span>Explore Blog →</span>
              </NavLink>

              <NavLink
                to="/casestudies"
                className="mega-column"
                onClick={closeMobileMenu}
              >
                <h4>Case Studies</h4>
                <p>Success stories and real client transformations.</p>
                <span>View Case Studies →</span>
              </NavLink>

              <NavLink
                to="/news"
                className="mega-column"
                onClick={closeMobileMenu}
              >
                <h4>News</h4>
                <p>Company announcements and latest updates.</p>
                <span>Read News →</span>
              </NavLink>

            </div>
          </div>
        </li>

        <li>
          <NavLink
            to="/contact"
            onClick={closeMobileMenu}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Contact
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/careers"
            onClick={closeMobileMenu}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Careers
          </NavLink>
        </li>

        {/* Mobile CTA */}
        <li className="mobile-cta">
          <NavLink to="/freedemo" onClick={closeMobileMenu}>
            <button className="demo-button">Book Free Demo</button>
          </NavLink>
        </li>
      </ul>

      {/* Desktop CTA */}
      <NavLink to="/freedemo" className="desktop-cta">
        <button className="demo-button">Book Free Demo</button>
      </NavLink>

      {/* Hamburger */}
      <div className="hamburger" onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav >
  );
};

export default Navbar;
